module.exports = __webpack_public_path__ + "a906ba689f26e466e65315725fa82ea6.png";